// ================================================================================
// swiper.js
// スワイパー用のスクリプトファイル
// ================================================================================

// News Tab
// --------------------------------------------------------------- //

export default function swiper() {

	const labSwiper = document.getElementById('lab-swiper');

	if ( labSwiper ) {
		const swiper = new Swiper(labSwiper, {
			initialSlide: 0,
			loop: true,
			speed: 1500,
			autoplay: {
				delay: 3600,
				//disableOnInteraction: false,
			},
			spaceBetween: 8,
			slidesPerView: 'auto',
			grabCursor: true,
			centeredSlides : true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: ".swiper-pagination",
				type: 'bullets',
				clickable: true,
			},
			breakpoints: {
				768: {
					spaceBetween: 24,
				}
			}
		});
	}

}
